var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"news"},on:{"click":_vm.closeNav}},[_c('dama-news')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }